<template>
  <mu-card id="downloadsPanel">
    <mu-card-header titleClass="blueTitle largeTitle" :title="$t('message.downloadsAppBarText')" :subTitle="$t('message.lessonDownloadsThisWeek')"></mu-card-header>
    <mu-list>
      <mu-list-item disableRipple @click.native="saveTrackingCount(download)"
        v-for="download, index in downloads"
        :key="'download-' + index"
        :title="download.title"
      >
        <mu-avatar slot="leftAvatar" :src="download.image_url"/>
        <span slot="describe">
          <span
            style="color: rgba(0, 0, 0, .87)"
            v-text="download.description">
          </span>
        </span>
        <mu-icon value="file_download" slot="right" @click.native="saveTrackingCount(download)" />
      </mu-list-item>
    </mu-list>
  </mu-card>
</template>
<script>

  import DiscussionApi from '../../../api/Discussion'
  import LessonApi from '../../../api/Lessons'


  export default {
    name: "downloads-panel",
    props: {
      downloads: {
        type: Array
      }
    },
    methods: {
      saveTrackingCount(download) {
        LessonApi.saveDownloadCount({
          download_id: download.download_id
        });
        window.open(download.link, '_blank');
      },
    },
    data () {
      return {

      }
    }
  }
</script>



// WEBPACK FOOTER //
// DownloadsPanel.vue?a3cccc5a